import * as yup from "yup";

export const characterAvatarValidationSchema = () => {
    return yup.object().shape({
        mode: yup.string().oneOf(["2d", "3d"]).required(),
        avatar_2d: yup.object().when("mode", {
            is: "2d",
            then: (schema) =>
                schema.shape({
                    idleVideoFile: yup.mixed<File>().nullable(),
                    talkingVideoFile: yup.mixed<File>().nullable(),
                }),
            otherwise: (schema) => schema.shape({}).default(undefined),
        }),
        avatar_3d: yup.object().when("mode", {
            is: "3d",
            then: (schema) =>
                schema.shape({
                    name: yup
                        .string()
                        .matches(/^[a-zA-Z_]+$/, "僅允許英文字母與底線")
                        .required("角色名稱為必填"),
                    vrmFile: yup.mixed<File>().nullable(),
                }),
            otherwise: (schema) => schema.shape({}).default(undefined),
        }),
    });
};
